import React, { useState, useContext } from 'react';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import Button from '../../NecttosComp/Button/Button';
import { Main, Header, Body } from '../../NecttosComp/Layout/Layout';
import { NecttosContext } from '../../context/NecttosContext';
import TimerFunction from './TimerFunction';

const HandleReject = ({
    userId,
    onClose,
    refectData,
    parentOnClose,
    startDateTimer,
    TimerFunction,
    toast
}) => {
    const [loading, setLoading] = useState(false);
    const [errorhandle, seterrorhandle] = useState('ok');
    const [acknowledged, setAcknowledged] = useState(false);

    const { profile } = useContext(NecttosContext);

    const handleSubmit = async () => {
        if (!acknowledged) return toast.error('Please acknowledge the rejection');

        setLoading(true);
        try {
            const payload = { _id: userId };
            const instance = await getAxiosTokenInstance();
            const response = await instance.post('/college/admissionProcess2/rejectUserFromVerification', payload);

            if (response?.data?.status !== 'success') {
                throw new Error(response?.data?.message || 'Reject failed');
            }

            if (response?.data?.message === 'User already rejected') {
                await refectData();
                onClose();
                await parentOnClose();
            }

            await refectData();
            onClose();
            await parentOnClose();
        } catch (error) {
            const Errormessageis = error?.response?.data?.message || error?.message;
            seterrorhandle(Errormessageis);
            toast.error(Errormessageis);
            console.error('Handle Reject Error:', Errormessageis);
        } finally {
            setLoading(false);
            toast.success('Reject Operation Successful');
            await refectData();
            onClose();
            await parentOnClose();
        }
    };

    return (
        <Main width="60%" height="60%" title="Reject Application">
            <Header>
                <div> <TimerFunction
                    start={true}
                    date={startDateTimer}
                    className="text-xl font-mono w-[100%] text-center rounded-lg p-3 ml-1 h-[40px] flex justify-center items-center  dark:bg-neutral-700 dark:text-slate-100   bg-slate-100 text-slate-800"
                /></div>
                <div className="flex justify-end">
                    <Button type="close" onClick={onClose}>
                        Close
                    </Button>
                </div>
            </Header>

            <Body>
                <div className="p-6 rounded-md shadow bg-slate-100 dark:bg-slate-800 text-slate-900 dark:text-white transition">
                    <div className="flex flex-col items-center gap-4 mb-4">
                        {profile?.photoURL ? (
                            <img
                                src={profile.photoURL}
                                alt="Profile"
                                className="w-28 h-28 rounded-xl border shadow-lg"
                            />
                        ) : (
                            <div className="text-sm text-slate-500 dark:text-slate-300">
                                No profile photo available
                            </div>
                        )}
                        <h3 className="text-lg font-semibold text-center text-red-600 dark:text-red-400">
                            Are you sure you want to reject this user?
                        </h3>
                    </div>

                    <div className="flex text-sm text-center items-center gap-2 mb-4">
                        <input
                            type="checkbox"
                            id="acknowledge"
                            checked={acknowledged}
                            onChange={(e) => setAcknowledged(e.target.checked)}
                            className="accent-red-600"
                        />
                        <label htmlFor="acknowledge" className='text-center flex items-center'>
                            I acknowledge that I am rejecting this application permanently.
                        </label>

                    </div>


                    <div className="flex justify-center gap-4">
                        <Button
                            onClick={handleSubmit}
                            disabled={loading || !acknowledged}
                            type="save"
                        >
                            {loading ? 'Rejecting...' : 'Confirm Reject'}
                        </Button>
                        <Button type="delete" onClick={onClose}>
                            Cancel
                        </Button>
                    </div>
                </div>
            </Body>
        </Main>
    );
};

export default HandleReject;
